import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Button as Btn } from 'components';
import { Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './ExamTemplateList.css';
const cx = classNames.bind(styles);

class ExamTemplateFilter extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { handleInitFilter, filterClose, cancleCheck, executeFilter, paramData, filters, tempFilter, popupOpen, handlePopup } = this.props;

    // 구분 필터
    const isServiceTemplate = [
      { 0: defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' })) },
      { 1: defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' })) }
    ];

    const serviceTemplateFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamTemplateList_1', defaultMessage: '구분' }))}
        />
        {isServiceTemplate.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.isServiceTemplateFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['isServiceTemplateArray'] &&
                      tempFilter['isServiceTemplateArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 훈련유형 필터
    const examType = [
      { 1: defineMessages(formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' })) },
      { 2: defineMessages(formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' })) },
      { 3: defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' })) },
      { 4: defineMessages(formatMessage({ id: 'ExamTemplateList_16', defaultMessage: '피싱 유도' })) }
    ];

    const examTypeFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamTemplateList_13', defaultMessage: '훈련 유형' }))}
        />
        {examType.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.examTypeTemplateFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['examTypeArray'] &&
                      tempFilter['examTypeArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 다운로드 유형 필터
    const downloadType = [
      { 1: defineMessages(formatMessage({ id: 'ExamTemplateList_29', defaultMessage: '첨부 파일' })) },
      { 2: defineMessages(formatMessage({ id: 'ExamTemplateList_28', defaultMessage: '링크 첨부' })) }
    ];

    const downloadTypeFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamTemplateList_27', defaultMessage: '다운로드 유형' }))}
        />
        {downloadType.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.downloadTypeTemplateFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['linkAttachArray'] &&
                      tempFilter['linkAttachArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 수신 성공 필터
    const receive = [
      { 0: defineMessages(formatMessage({ id: 'ExamTemplateList_34', defaultMessage: '수신 실패' })) },
      { 1: defineMessages(formatMessage({ id: 'ExamTemplateList_12', defaultMessage: '수신 성공' })) }
    ];

    const receiveTemplateFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamTemplateList_12', defaultMesssage: '수신 성공' }))}
        />
        {receive.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.receiveTemplateFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['templateReceiveArray'] &&
                      tempFilter['templateReceiveArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    let isServiceTemplateArray =
      paramData.getIn(['filter', 'isServiceTemplateArray']) &&
      paramData.getIn(['filter', 'isServiceTemplateArray']).toJS();

    let examTypeArray =
      paramData.getIn(['filter', 'examTypeArray']) && paramData.getIn(['filter', 'examTypeArray']).toJS();

    let linkAttachArray =
      paramData.getIn(['filter', 'linkAttachArray']) && paramData.getIn(['filter', 'linkAttachArray']).toJS();

    let templateReceiveArray =
      paramData.getIn(['filter', 'templateReceiveArray']) && paramData.getIn(['filter', 'templateReceiveArray']).toJS();

    if (isServiceTemplateArray === undefined) {
      isServiceTemplateArray = [];
    }
    if (examTypeArray === undefined) {
      examTypeArray = [];
    }
    if (linkAttachArray === undefined) {
      linkAttachArray = [];
    }

    if (templateReceiveArray === undefined) {
      templateReceiveArray = [];
    }

    const totalArrayLength =
      isServiceTemplateArray.length + examTypeArray.length + linkAttachArray.length + templateReceiveArray.length;

    let isServiceTemplateInfo = null;
    let examTypeInfo = null;
    let linkAttachInfo = null;
    let templateReceiveInfo = null;

    if (isServiceTemplateArray.length > 0) {
      isServiceTemplateInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamTemplateList_1', defaultMessage: '구분' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {isServiceTemplateArray.map((isServiceTemplate, index) => {
              const isServiceTemplateArray =
                paramData.getIn(['filter', 'isServiceTemplateArray']) &&
                paramData.getIn(['filter', 'isServiceTemplateArray']).toJS();

              let templateStatus = '';
              if (isServiceTemplateArray[index] === '0') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' }));
              } else if (isServiceTemplateArray[index] === '1') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' }));
              }

              const text =
                isServiceTemplateArray[isServiceTemplateArray.length - 1] !== isServiceTemplateArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }
    if (examTypeArray.length > 0) {
      examTypeInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamTemplateList_13', defaultMessage: '훈련 유형' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {examTypeArray.map((examType, index) => {
              const examTypeArray =
                paramData.getIn(['filter', 'examTypeArray']) && paramData.getIn(['filter', 'examTypeArray']).toJS();
              let templateStatus = '';
              if (examTypeArray[index] === '1') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' })
                );
              } else if (examTypeArray[index] === '2') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' })
                );
              } else if (examTypeArray[index] === '3') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' })
                );
              } else if (examTypeArray[index] === '4') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_16', defaultMessage: '피싱 유도' })
                );
              }

              const text =
                examTypeArray[examTypeArray.length - 1] !== examTypeArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }
    if (linkAttachArray.length > 0) {
      linkAttachInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamTemplateList_27', defaultMesssage: '다운로드 유형' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {linkAttachArray.map((linkAttach, index) => {
              const linkAttachArray =
                paramData.getIn(['filter', 'linkAttachArray']) && paramData.getIn(['filter', 'linkAttachArray']).toJS();
              let templateStatus = '';
              if (linkAttachArray[index] === '1') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_29', defaultMessage: '첨부 파일' })
                );
              } else if (linkAttachArray[index] === '2') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_28', defaultMessage: '링크 첨부' })
                );
              }

              const text =
                linkAttachArray[linkAttachArray.length - 1] !== linkAttachArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }
    if (templateReceiveArray.length > 0) {
      templateReceiveInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamTemplateList_12', defaultMesssage: '수신 성공' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {templateReceiveArray.map((templateReceive, index) => {
              const templateReceiveArray =
                paramData.getIn(['filter', 'templateReceiveArray']) &&
                paramData.getIn(['filter', 'templateReceiveArray']).toJS();
              let templateStatus = '';
              if (templateReceiveArray[index] === '1') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_12', defaultMessage: '수신 성공' })
                );
              } else if (templateReceiveArray[index] === '0') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_34', defaultMessage: '수신 실패' })
                );
              }

              const text =
                templateReceiveArray[templateReceiveArray.length - 1] !== templateReceiveArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }

    // 툴팁 정보
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />
        {isServiceTemplateInfo}
        {examTypeInfo}
        {linkAttachInfo}
        {templateReceiveInfo}
      </div>
    );

    return (
      <Tooltip
        classes={{
          tooltip: 'tooltip',
          tooltipOpen: totalArrayLength > 0 ? '' : 'close'
        }}
        title={tooltipInfo}
        placement="bottom">
        <div className={cx('target-dropdown-area', totalArrayLength > 0 ? 'target-dropdown-area-border' : '')}>
          <div className={cx('dropdown-arrow-area', 'table-filter-arrow')}>
            {totalArrayLength > 0 ? (
              <div className={cx('number-box')}>{totalArrayLength}</div>
            ) : (
                <Image className={cx('dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
              )}
          </div>
          <Popup
            className={cx('filter-popup')}
            trigger={
              <div className={cx('default-text', totalArrayLength > 0 ? 'filter-length' : '')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_35', defaultMessage: '필터' }))}
              </div>
            }
            open={popupOpen}
            onOpen={() => handlePopup(true)}
            onClose={() => { filterClose(), handlePopup(false) }}
            on="click"
            flowing
            open={popupOpen}
            position="bottom center">
            <Grid centered divided columns={4}>
              <Grid.Column textAlign="left">{serviceTemplateFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{examTypeFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{downloadTypeFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{receiveTemplateFilterOptions}</Grid.Column>
            </Grid>
            <Grid className={cx('bottom-options')}>
              <Grid.Column>
                <div className={cx('all-check-off')} onClick={handleInitFilter}>
                  {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                </div>
                <div className={cx('inline-block')}>
                  <Btn className={cx('button-border', 'button')} onClick={() => { cancleCheck(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                  </Btn>
                  <Btn
                    className={cx('button-brand', 'button')}
                    // loading={editOnProgress}
                    // disabled={disableSave && (editInvalid || editOnProgress)}
                    onClick={() => { executeFilter(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                  </Btn>
                </div>
              </Grid.Column>
            </Grid>
          </Popup>
        </div>
      </Tooltip>
    );
  }
}

export default injectIntl(ExamTemplateFilter);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamTemplateFilter.js